import { render, staticRenderFns } from "./actuals_moovs.vue?vue&type=template&id=ffe871e8&"
import script from "./actuals_moovs.vue?vue&type=script&lang=js&"
export * from "./actuals_moovs.vue?vue&type=script&lang=js&"
import style0 from "./actuals_moovs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports